/* arabicGender — يَستنتج جنس المُتلقّي من اسمه (عربي أو لاتيني).
   لا يَعتمد على أي API — قاموس أسماء عراقي شائع + قواعد صَرفية بسيطة. */

/* أسماء ذكور عراقيّة شائعة (مع تَطبيع الهمزات والألفات). */
const MALE = new Set([
  // كلاسيكية
  "علي","احمد","محمد","حسن","حسين","حسنين","عمر","خالد","يوسف","محمود","ابراهيم",
  "عبدالله","عبدالرحمن","عبدالكريم","عبدالحسين","عبدالرزاق","عبدالعزيز","عبدالستار",
  "عبدالقادر","عبدالمجيد","عبدالهادي","عبدالامير","عبدالجبار","عبدالصمد","عبدالواحد",
  "عبدالحسن","عبدالنبي","عبدالمهدي","عبدالحميد","عبدالخالق","عبدالرضا","عبدالوهاب",
  "عبدالغني","عبدالسلام","عبدالمنعم","عبدالفتاح","عبدالرؤوف","عبدالباقي","عبدالعالي",
  // عراقيّة شائعة
  "فؤاد","سامي","طارق","كريم","رياض","فيصل","صادق","جعفر","باقر","مهدي",
  "حيدر","سجاد","مرتضى","مصطفى","مهند","نور الدين","امير","نزار","ماجد","عماد",
  "مازن","رامي","فاضل","حازم","باسل","وليد","رعد","فاروق","نبيل","زيد",
  "جمال","عادل","حسام","رؤوف","ربيع","ثائر","عاصم","جابر","قاسم","ياسر",
  "وسام","ليث","غسان","مازن","معتز","طلال","ضرغام","ضياء","صبيح","عبد",
  "ايمن","ايهاب","انور","انس","بسام","بشار","تيسير","توفيق","جلال","جمعة",
  "حامد","حاتم","حبيب","حمزة","حنون","رافد","رامي","رفيق","سعد","سعيد",
  "سلمان","سليم","سمير","سيف","شاكر","شريف","صفاء","ضياء","طاهر","عابد",
  "عاطف","عبدالكاظم","عبدالباري","عقيل","علاء","عمار","فارس","فلاح","قيس","كاظم",
  "كمال","لطيف","ماهر","مالك","مجيد","محسن","مرعي","مشتاق","مصعب","معاذ",
  "ممتاز","منذر","موسى","نادر","نايف","نضال","هاني","هشام","هيثم","وائل",
  "ودود","يحيى","يونس","ياسين","زاهر","زهير","غازي","صلاح","صباح",
  // إضافات 2026-07-07: أسماء يستخدمها محامون في قاعدة الإنتاج ولم تكن مُغطاة
  "الحسين","الحسن","الحيدر","المرتضى","المهدي","الياس","اسحاق","اسماعيل",
  "بلال","تحسين","جواد","حكيم","حيدر","خضير","خليل","داوود","ذاكر","ذوالفقار",
  "رافل","رعد الله","سلام","سلمان","صفاء","صادق","صفوان","طه","عبد الجليل","عبد الحكيم",
  "عبد الرزاق","عثمان","عزيز","عصام","علي حسن","علي محمد","علي أكبر","علي رضا","علي أصغر",
  "غانم","فاروق","فراس","قحطان","كرار","لؤي","محمد باقر","محمد جواد","محمد صادق","محمد علي",
  "محمد حسين","محمد رضا","محمد صالح","محمد كاظم","محمد أمين","مرتضى","مسلم","معاذ","منتظر",
  "منير","ناجي","ناصر","نجم","نعمان","نعيم","هادي","وائل","وضاح","وليد",
  "يعقوب","يوسف","حسنون","حسناوي","علاوي",
]);

/* أسماء إناث عراقيّة شائعة. */
const FEMALE = new Set([
  // كلاسيكية
  "فاطمة","زينب","عائشة","خديجة","رقية","سكينة","ايه","ايات","ايات الله","اية",
  "مريم","سارة","ساره","نور","هدى","امل","ايمان","سعاد","شيماء","ميساء",
  "حنان","رغد","رؤى","ليلى","سلمى","ندى","علياء","عبير","نهى","رشا",
  "رنين","دانية","جنى","بتول","عذراء","فدوى","فردوس","ابتسام","ابتهاج","ثناء",
  "سهام","سها","شذى","نسرين","رنا","رنا","ايلاف","تالا","تيماء","جوري",
  // عراقيّة معاصرة
  "ضحى","رهف","ريم","ريما","ريهام","شهد","غدير","غيداء","نرجس","نسمة",
  "هبة","هند","وعد","ياسمين","يسرا","سندس","لمياء","لمى","لمار","مايا",
  "ميس","نادية","نازك","نجلاء","نجوى","نسيبة","هاجر","هالة","هيا","رزان",
  "اسماء","اسيل","افنان","الهام","امينة","انسام","ايلين","بان","بشرى","تبارك",
  "تماره","جنان","حسناء","حليمة","حوراء","رحاب","رحمة","رفيف","روان","روعة",
  "ريف","زمن","زهراء","زهرة","سحر","سما","سندس","سيرين","شذا","شروق",
  "شمائل","شيراز","صفاء","صابرين","ضوء","عبلة","عفاف","علا","عواطف","غادة",
  "فادية","فاطمه","فجر","فرح","فيروز","كرمة","لارا","لارين","لمار","ليان",
  "لين","ماجدة","مارية","مايا","مرام","ملاك","منار","منى","مها","نهلة",
  "نور الهدى","نوره","هديل","هنادي","وفاء","يارا","يسرى","يمنى","نبأ","رهام",
]);

/* أسماء بِأَلفبائيّة لاتينيّة (تَنتشر في تَطبيقاتنا حين يُدخل المحامي اسماً بدون عربيّة). */
const MALE_LATIN = new Set([
  "ali","ahmad","ahmed","mohammed","mohamed","muhammad","hassan","husain","hussein",
  "omar","umar","khalid","khaled","yousif","yousef","yusuf","mahmoud","ibrahim",
  "abdullah","abdulrahman","abdulkarim","fouad","fuad","sami","tarek","tariq",
  "kareem","karim","riyadh","faisal","sadiq","jaffar","jafar","baqir","mahdi",
  "haider","hayder","sajjad","murtadha","mustafa","muhanad","nuruldin","ameer",
  "amir","emad","mazen","rami","fadhil","hazem","basel","walid","raed","farouk",
  "nabil","zaid","jamal","adil","husam","raouf","rabee","thaer","asim","jaber",
  "qasim","yasser","wasam","wisam","laith","ghassan","mu3taz","muataz","talal",
  "diaa","zia","sabah","aymen","ayman","ayhab","ihab","anwar","ans","anas","bassam",
  "bashar","jalal","hamed","hatim","habib","hamza","rafid","saad","saeed","said",
  "salman","saleem","salim","samir","sayf","saif","shaker","sharif","safaa","tahir",
  "ali al","abed","atef","alaa","ammar","fares","faris","fallah","qais","kazem",
  "kamal","latif","maher","malik","majeed","majid","mohsen","mortadha","mortadhda",
  "mosab","muath","mortaha","montather","moosa","musa","nader","nayef","nidhal",
  "hani","hisham","hytham","haitham","wael","yahya","younis","yunis","yasin",
  "zaher","zuhair","ghazi","salah",
]);
const FEMALE_LATIN = new Set([
  "fatma","fatima","zaynab","zainab","aisha","khadija","ruqaya","sukaina","aya","ayah",
  "ayat","mariam","maryam","sarah","sara","noor","nour","huda","amal","iman","eman",
  "souad","shaimaa","maysa","hanan","rghd","raghad","rua","ruaa","layla","laila",
  "salma","nada","alia","alyaa","abeer","abir","noha","rasha","raneen","dania","danya",
  "jana","jenna","batool","fadwa","firdaws","ebtisam","ebtihaj","thanaa","seham","saham",
  "soha","shaza","nisreen","rana","ranna","tala","jouri","duha","rahaf","reem","reema",
  "reham","shahd","shaheed","ghadeer","ghada","gheidaa","narges","narjis","nasma",
  "heba","hiba","hind","ya'd","wa'd","yasmeen","yusra","sundus","lamya","lama","lamar",
  "maya","mais","nadia","nazek","najla","najwa","haajar","hagar","hala","hayya","heyya",
  "razan","asmaa","aseel","afnan","ilham","amna","amina","ansam","aylin","ban","bushra",
  "tabarak","tamara","jenan","hasnaa","haleema","hawraa","rehab","rahma","rafeef","rawan",
  "rouaa","reef","zaman","zahra","zahraa","zahrah","sahar","sama","sireen","shaza","shoroq",
  "shroq","shamael","sheraz","safaa","sabreen","dawa","abla","afaf","ola","awatif","ghada",
  "fadia","fajr","farah","fairouz","karma","lara","lareen","layan","leen","majida","mariya",
  "mayya","maram","malak","manar","muna","mona","maha","nahla","noora","noura","hadeel",
  "hanadi","wafaa","yara","yusra","yumna","nabaa","reham",
]);

/* تَطبيع: إزالة التشكيل + تَوحيد الهمزات + lower-case للاتيني. */
function normalize(raw) {
  if (!raw) return "";
  return String(raw)
    .toLowerCase()
    .replace(/[\u0617-\u061A\u064B-\u0652\u0670\u06D6-\u06ED]/g, "") // التشكيل
    .replace(/[إأآا]/g, "ا")
    .replace(/ى/g, "ي")
    .replace(/ؤ/g, "و")
    .replace(/ئ/g, "ي")
    .replace(/ة/g, "ه")
    .replace(/\s+/g, " ")
    .trim();
}

/* تَطبيع المجموعتين مرّة واحدة عند تحميل الموديول لِضمان مطابقة موحَّدة. */
const MALE_N = new Set([...MALE].map(normalize));
const FEMALE_N = new Set([...FEMALE].map(normalize));
const MALE_LATIN_N = new Set([...MALE_LATIN].map((x) => x.toLowerCase()));
const FEMALE_LATIN_N = new Set([...FEMALE_LATIN].map((x) => x.toLowerCase()));

/* الألقاب/الرُّتَب التي يَستَخدِمها المحامون قبل أَسمائهم في التَّسجيل
   (شائع في العراق أَن يَكتُب المحامي "الأستاذ محمد الجبوري" أو
   "المحامية زَينَب"). لَو لم نَتَخَطَّاها، `firstWord` يأخذ اللقب
   كأنّه أول اسم فيَفشَل الكَشف تلقائيّاً على كل محامٍ يُضيف لَقَبه. */
const TITLE_PREFIXES = new Set([
  "الاستاذ", "الاستاذه",   // بعد التطبيع (ة → ه)
  "استاذ", "استاذه",
  "المحامي", "المحاميه",
  "محامي", "محاميه",
  "الدكتور", "الدكتوره",
  "دكتور", "دكتوره",
  "السيد", "السيده",
  "سيد", "سيده",
  "الحاج", "الحاجه",
  "حاج", "حاجه",
  "الشيخ", "الشيخه",
  "شيخ", "شيخه",
  "المهندس", "المهندسه",
  "مهندس", "مهندسه",
  "القاضي", "القاضيه",
  "قاضي", "قاضيه",
  "اللواء", "الفريق", "العميد", "العقيد", "الرائد", "النقيب",
  "الملازم", "المقدم",
  "الاخ", "الاخت",
  "الحبيب", "العزيز",
]);

/* أوّل كلمة "حقيقيّة" في الاسم (تَتجاهل "أ." و "د." و "م." + الألقاب). */
function firstWord(raw) {
  const parts = normalize(raw).split(" ").filter((p) => {
    if (!p) return false;
    if (/^[امد]\.?$/.test(p)) return false;   // "أ." "د." "م."
    if (TITLE_PREFIXES.has(p)) return false; // "الأستاذ" "الدكتورة" …
    return true;
  });
  return parts[0] || "";
}

/* قواعد صَرفيّة سريعة على الكلمة العربيّة الأولى.

   ⚠️ التَّوسُّع في 2026-07-07: القواعد السَّابقة كانت مُقتَصِرة على
   المؤنَّث فقط، فَحَتّى أَسماء مُذَكَّر تَنتَهي بِـ ين/ون/ان (حسنين،
   عثمان) كانت تَرجع unknown → "الأستاذ/ة" في بِطاقة المحامي. */
function arabicSuffixHint(word) {
  if (!word || word.length < 3) return null;
  // ── مُؤنَّث ──
  // ينتهي بهاء (تاء مربوطة) — غالباً أنثى (فاطمه، سعاده، عائشه...)
  if (/ه$/.test(word) && word.length >= 4) return "female";
  // ينتهي بـ "اء" — غالباً أنثى (شيماء، أسماء، دعاء...)
  if (/اء$/.test(word)) return "female";
  // ينتهي بـ "ي" (بعد التطبيع لِـ ى) — يَعتمِد على الحرف الأول
  if (/ي$/.test(word) && word.length >= 4 && /^[لنرسحمزهد]/.test(word)) return "female";
  // ينتهي بـ "ى" الأصليّة أو بعد التطبيع لِـ ي — أَسماء أُنثويّة شائعة
  // (مثال قد يَفوته: "لبنى"، "سلمى"، "بشرى")
  if (/(ن|م|ر|س|ح|ل|د)ى$/.test(word)) return "female";
  // ── مُذَكَّر ──
  // ينتهي بـ "ين" (حسنين، أمين، دلشاد، شامل) — غالباً مذكّر
  if (/ين$/.test(word) && word.length >= 4) return "male";
  // ينتهي بـ "ون" (هارون، ذنون) — غالباً مذكّر
  if (/ون$/.test(word) && word.length >= 4) return "male";
  // ينتهي بـ "ان" (سلمان، رمضان، مروان، عثمان، شعبان) — غالباً مذكّر
  if (/ان$/.test(word) && word.length >= 4) return "male";
  // يبدأ بِـ "عبد" — دائماً مذكّر ("عبدالله"، "عبد الرزاق"، إلخ)
  if (/^عبد/.test(word)) return "male";
  return null;
}

/* النتيجة الرئيسيّة. تَرجع: "male" | "female" | "unknown". */
export function detectGender(fullName) {
  const word = firstWord(fullName);
  if (!word) return "unknown";
  if (MALE_N.has(word)) return "male";
  if (FEMALE_N.has(word)) return "female";
  // لاتيني
  const latinWord = word.replace(/[^a-z]/g, "");
  if (latinWord) {
    if (MALE_LATIN_N.has(latinWord)) return "male";
    if (FEMALE_LATIN_N.has(latinWord)) return "female";
  }
  // قواعد لاحقة
  const hint = arabicSuffixHint(word);
  if (hint) return hint;
  return "unknown";
}

/* صياغة "الأستاذ/ة <اسم> المحترم/ة" بِشكل صحيح حسب الجنس. */
export function honorific(fullName) {
  const g = detectGender(fullName);
  const name = (fullName || "").trim() || "المحترم";
  if (g === "male")   return { title: "الأستاذ",  respect: "المحترم",  brotherly: "الأخ",   addressee: name };
  if (g === "female") return { title: "الأستاذة", respect: "المحترمة", brotherly: "الأخت",  addressee: name };
  return                    { title: "الأستاذ/ة", respect: "المحترم/ة", brotherly: "الأخ/الأخت", addressee: name };
}
